import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Core pages
import KentAcademyHomepage from './components/KentAcademyHomepage';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import ContactUs from './components/ContactUs';

// Existing courses
import LaserCoursePage from './components/LaserCoursePage';
import TattooRemovalCoursePage from './components/TattooRemovalCoursePage';
import VietnameseNailCoursePage from './components/VietnameseNailCoursePage';


// Level 3 – English
import Level3Welcome from './components/Level3Welcome';
import Level3Register from './components/Level3Register';
import Level3Tasks from './components/Level3Tasks';
function App() {
  return (
    <Router>
      <Routes>
        {/* Core */}
        <Route path="/" element={<KentAcademyHomepage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />

        {/* Existing courses */}
        <Route path="/courses/laser-and-light" element={<LaserCoursePage />} />
        <Route path="/courses/tattoo-removal" element={<TattooRemovalCoursePage />} />
        <Route path="/courses/vietnamese-nails" element={<VietnameseNailCoursePage />} />

        {/* Level 3 – English */}
        <Route path="/courses/level-3/welcome" element={<Level3Welcome />} />
        <Route path="/courses/level-3/register" element={<Level3Register />} />
        <Route path="/courses/level-3/tasks" element={<Level3Tasks />} />
        
      </Routes>
    </Router>
  );
}

export default App;
